/* @flow */

import _ from 'lodash';

import stepData from '../data/stepData.json';

type KeyedFieldsType = { fields: string[], id: string };

export const StepToKeyMap = _.reduce(stepData, (accuml: KeyedFieldsType[], step: StepData, id: string) => {
  const subSteps = _.get(step, ['steps'], {});
  const fields: string[] = _.reduce(subSteps, (o, d) => [].concat(o, Object.keys(d.fields)), []);
  const item: KeyedFieldsType = { id, fields };
  return _.isEmpty(fields) ? accuml : _.concat(accuml, item);
}, []);

export const KeyToStepMap = _.reduce(stepData, (accuml: {}, step: StepData, id: string) => {
  const subSteps = _.get(step, ['steps'], {});
  const fields: [number, string][] = _.reduce(
    subSteps,
    (o, d) => [].concat(o, Object.keys(d.fields).map(k => [k, id])),
    [],
  );
  const obj = _.fromPairs(fields);
  return { ...accuml, ...obj };
}, {});

export const StepOrder: Array<string> = _.reduce(
  stepData,
  (accuml: string[], step: StepData) => _.concat(accuml, step.id),
  [],
);

export const getStepDataByKey: (step: string) => StepData = _.memoize((key: string) => stepData[key]);

/**
 * Returns the parent step given a field.
 *
 * @export
 * @param {string} field
 * @returns {string | null}
 */
export function getStepByField(field: string): string | null {
  return field ? KeyToStepMap[field] : null;
}

/**
 * Returns a list of fields given a step id
 *
 * @export
 * @param {string} field
 * @returns {string[]}
 */
export function getStepFields(field: string): Array<*> {
  return _.filter(StepToKeyMap, step => step.fields.includes(field));
}

export function getNextFieldsByStep(step: string): string[] {
  const index = _.findIndex(StepToKeyMap, s => s.id === step);
  const remaining = _.slice(StepToKeyMap, index)
    .filter(i => i)
    .map(i => i.fields);
  return _.flatten(remaining);
  // return [];
}

export function getNextFields(/* field: string */) {
  // const step = getStepByField(field);
  // const stepIndex = _.findIndex(stepToKeyMap, ['id', step]);
  // const remaininSteps = _.slice(stepToKeyMap, stepIndex);

  // const partialStep = _.get(stepToKeyMap, [step, 'fields'], []);
  // const fieldIndex = _.findIndex(partialStep, field);
  // const remainingFields = _.slice(partialStep, fieldIndex);
  // console.log(stepIndex, remainingFields, _.flatten(remaininSteps));
  return [];
}



// WEBPACK FOOTER //
// ./src/utils/stepHelpers.js